import { render } from "./UserAuth.vue?vue&type=template&id=43a920b1&scoped=true"
import script from "./UserAuth.vue?vue&type=script&lang=js"
export * from "./UserAuth.vue?vue&type=script&lang=js"

import "./UserAuth.vue?vue&type=style&index=0&id=43a920b1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43a920b1"

export default script